import { LibraryStore } from "./LibraryStore";
import {
  createLibraryModelFromDocument,
  createNewLibrary,
  Library,
} from "./models/Library";
import { default as firebase, firestore, storage } from "common/Firebase";
import { DevelopmentReference } from "modules/development/models/Index";
import { DevelopmentStore } from "modules/development/DevelopmentStore";
import { FirebaseDocument } from "common/models/FirebaseDocument";
import { Render3dService } from "modules/render3D/Render3dService";
import * as _ from "lodash";
import { WBSStore } from "modules/WBS/WBSStore";
import { Render3dStore } from "modules/render3D/Render3dStore";
import i18n from "i18n";
import { LoginStore } from "modules/login/LoginStore";
import { now } from "utils/FirebaseUtils";
import { gtag } from "ga-gtag";
import axios from "axios";

/**
 * Service de arquivo 3D.
 * @category Files
 * @hideconstructor
 */
class LibraryService {
  /** Altera a propriedade enable do modelo para verdadeiro caso seja falso, e vice-versa.
   * Atualizando as listas em que o modelo se encontra e salvando o valor no banco
   * de dados.
   */
  async toggleRenderLibrary(lib: FirebaseDocument<Library>) {
    try {
      if (lib === null || lib == undefined) {
        throw new Error(i18n.library.message.errorEnableRenderFile);
      }

      // Atualiza valor no listWbs caso
      if (!(WBSStore.listWbs && WBSStore.listWbs.length)) {
        if (lib.data.development)
          await WBSStore.getWbsById(lib.data.development.id);
      }

      lib.data.enabled = !lib.data.enabled;

      await firestore.collection("files").doc(lib.id).update({
        enabled: lib.data.enabled,
      });

      await LibraryStore.setLibrary(lib);
      await this.setLibraryRender3D(lib);
    } catch (e) {}
  }

  async setLibraryRender3D(lib: FirebaseDocument<Library>) {
    var modelId = Render3dStore.modelIdCollection.find((m: any, index) => {
      var mId = m.tag.toLowerCase() === lib.id.toLowerCase();
      return mId;
    }) as any;

    if (modelId !== undefined) {
      Render3dService.viewerRemoveIFC(lib);
    } else {
      Render3dService.mountRender3D();
    }
  }

  async recreateLibrary(lib: FirebaseDocument<Library>): Promise<string> {
    let library = new Library(
      lib.data.name,
      "pending",
      lib.data.createdAt,
      lib.data.type,
      lib.data.realFileName,
      lib.data.fileSize,
      lib.data.development,
      false,
      lib.data.erro,
      lib.data.modifyAt,
      "0",
      "pending",
      "0",
      false,
      false,
      "",
      "",
      0
    );
    let newId: string = "";
    await firestore
      .collection("files")
      .add({ ...library })
      .then((docRef) => {
        newId = docRef.id;
      })
      .catch((error) => {
        console.log(error);
      });

    return newId;
  }

  async deleteLibrary(lib: string) {
    try {
      axios.post(`${process.env.REACT_APP_DELETE_FILE_ITEMS}`, {
        modelId: lib,
        projectId: DevelopmentStore.developmentId,
      });
      axios.post(`${process.env.REACT_APP_DELETE_FILE_ITEMS_IFC_REF}`, {
        modelId: lib,
        projectId: DevelopmentStore.developmentId,
      });
      axios.post(`${process.env.REACT_APP_DELETE_FILE_OTHER_COLLECTIONS}`, {
        modelId: lib,
        projectId: DevelopmentStore.developmentId,
      });
      await firestore.collection("files").doc(lib).set({});
    } catch (e) {
      console.log(e);
    }
  }
  async restartProcesses(lib) {
    let checkStatus = await firestore.collection("files").doc(lib.id).get();
    let data = checkStatus.data();
    let fileName = lib.data.name;
    const ifcReadPropertiesTask = firebase
      .functions()
      .httpsCallable("ifcReadPropertiesTask");
    let id = lib.id;
    if (data != null) {
      if (data.status == "error") {
        await firestore
          .collection("files")
          .doc(lib.id)
          .update({ status: "pending" });
        id = await this.recreateLibrary(lib);

        await this.deleteLibrary(lib.id);
        await ifcReadPropertiesTask({
          id: id,
          fileName: fileName,
        })
          .then(async (response) => {})
          .catch((error) => {
            console.log(error);
          });
        const ifcToXktTask = firebase.functions().httpsCallable("ifcToXktTask");

        await ifcToXktTask({
          id: id,
          fileName: fileName,
        })
          .then(async (response) => {})
          .catch((error) => {
            console.log(error);
          });
      }
      if (data.statusXkt == "error") {
        await firestore
          .collection("files")
          .doc(lib.id)
          .update({ statusXkt: "pending", enabled: false });

        await ifcReadPropertiesTask({
          id: id,
          fileName: fileName,
        })
          .then(async (response) => {})
          .catch((error) => {
            console.log(error);
          });
        const ifcToXktTask = firebase.functions().httpsCallable("ifcToXktTask");

        await ifcToXktTask({
          id: id,
          fileName: fileName,
        })
          .then(async (response) => {})
          .catch((error) => {
            console.log(error);
          });
      }
    }
  }

  async fetchLibrariesFromDataBase(
    developmentId: string,
    callback
  ): Promise<void> {
    try {
      LoginStore.clearFilesSnapshot();
      LoginStore.filesSnapshot = await firestore
        .collection("files")
        .where("development.id", "==", developmentId)
        .onSnapshot(callback);
    } catch (e) {}
  }

  async updateLibrariesToXeokit(developmentId: string): Promise<void> {
    return firestore
      .collection("developments")
      .doc(developmentId)
      .update({ isXeokitViewer: true });
  }

  async fetchFilesByName(file: FirebaseDocument<Library>): Promise<any> {
    try {
      const files = await firestore
        .collection("files")
        .where("name", "==", file.data.name)
        .get();

      let ret = new Array();
      for (let file of files.docs) {
        ret.push(createLibraryModelFromDocument(file));
      }
      return ret;
    } catch (e) {}
  }

  async ExistsFiles(devId: string): Promise<boolean> {
    try {
      const files = await firestore
        .collection("files")
        .where("development.id", "==", devId)
        .get();

      return files.docs && files.docs.length > 0;
    } catch (e) {
      return false;
    }
  }

  async DeleteLibrary(library: FirebaseDocument<Library>): Promise<void> {
    try {
      // Marca o status do arquivo como excluído, para disparar a CLoud Function com trigger no update dos documentos dessa coleção
      await firestore
        .collection("files")
        .doc(library.id)
        .update({ status: "deleted" });

      await firestore
        .collection("files")
        .doc(library.id)
        .update({ statusXkt: "deleted" });

      this.DeleteItemsFromView(library);
      LibraryStore.librarySelected = undefined;
    } catch (e) {
      console.log("Error to delete Lybrary: ", e);
    }
  }

  async DeleteItemsFromView(library: FirebaseDocument<Library>): Promise<void> {
    var modelId = Render3dStore.modelIdCollection.find((m: any, index) => {
      var mId = m.tag.toLowerCase() === library.id.toLowerCase();
      return mId;
    }) as any;
    if (modelId) {
      let itemsView: any = [...Render3dStore.itemsView];
      let itemsFiltered = _.filter(itemsView, function (o) {
        return o.modelId !== modelId.model; //PRUBK-754
      });
      Render3dStore.itemsView = itemsFiltered;
    }
  }

  /**
   * Faz o upload do arquivo IFC para a pasta ifc/ do Storage e cria o documento
   * referente ao modelo. Ao final chama o serviço que fará a conversão do arquivo
   * IFC para extrair seus elementos e propriedades, e gerar o arquivo que será
   * lido pelo Visualizador 3D atual.
   * @param {File} file - Arquivo que será upado
   * @param {DevelopmentReference} development - Dados do projeto selecionado
   */
  async AddLibrary(
    file: File,
    development: DevelopmentReference
  ): Promise<void> {
    let library = createNewLibrary(file, development);
    let upFiles = LibraryStore.libraryUploading.length;

    try {
      LibraryStore.libraryUploading[upFiles - 1].uploadTask = storage
        .ref()
        .child("ifc/" + library.name)
        .put(file);

      await LibraryStore.libraryUploading[upFiles - 1].uploadTask.on(
        firebase.storage.TaskEvent.STATE_CHANGED,
        (snapshot) => {
          let result = this.updatePercentage(upFiles, snapshot, 1);
          if (result == false) {
            LibraryStore.progressStatusUpload = 100;
          }
        }
      );

      if (LibraryStore.libraryUploading[upFiles - 1]) {
        await LibraryStore.libraryUploading[upFiles - 1].uploadTask; // to wait upload to finish
      }

      LibraryStore.libraryUploading[upFiles - 1].loading = 0;

      library.development = { ...development };
      let fileId = await firestore.collection("files").add({
        ...library,
        createdAt: now(),
      });

      gtag("event", "importacao_modelo", {
        importacao_modelo: 0,
      });

      this.readPropertiesAndConvertIfc(fileId.id, library.name);
    } catch (e) {
      console.log("erro: ", e);
      LibraryStore.libraryUploading.splice(upFiles - 1, 1);
      if (e.code !== "storage/canceled") LibraryStore.snack = true;
    }
  }

  async readPropertiesAndConvertIfc(fileId, fileName) {
    const ifcReadPropertiesTask = firebase
      .functions()
      .httpsCallable("ifcReadPropertiesTask");

    await ifcReadPropertiesTask({
      id: fileId,
      fileName: fileName,
    })
      .then(async (response) => {})
      .catch((error) => {
        console.log(error);
      });

    const ifcToXktTask = firebase.functions().httpsCallable("ifcToXktTask");

    await ifcToXktTask({
      id: fileId,
      fileName: fileName,
    })
      .then(async (response) => {})
      .catch((error) => {
        console.log(error);
      });
  }

  updatePercentage = (upFiles, snapshot, index) => {
    let result = false;
    if (upFiles - index < 0) {
      return false;
    }
    if (LibraryStore.libraryUploading[upFiles - index]) {
      LibraryStore.libraryUploading[upFiles - index].loading =
        (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
      LibraryStore.progressStatusUpload =
        (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
      result = true;
    } else {
      result = this.updatePercentage(upFiles, snapshot, index + 1);
    }
    return result;
  };
}

const service = new LibraryService();
export { service as LibraryService };



// WEBPACK FOOTER //
// ./src/modules/library/LibraryService.ts